import { ExternalFileStatus, FileUploadEnergyType, FileUploadFileType } from "./file-upload-interfaces";

export interface BaseJSONGeneratorHistoryGet {
  id: string;
  created_at: string;
  updated_at: string;
  file_name?: string;
  json_history?: { [key: string]: any };
}

export interface BaseJSONGeneratorHistoryCreate {
  file_name?: string;
  json_history?: { [key: string]: any };
}

export interface JSONGeneratorHistoryElectricityGet extends BaseJSONGeneratorHistoryGet { }

export interface JSONGeneratorHistoryElectricityCreate extends BaseJSONGeneratorHistoryCreate { }

export interface JSONGeneratorHistoryGasGet extends BaseJSONGeneratorHistoryGet { }

export interface JSONGeneratorHistoryGasCreate extends BaseJSONGeneratorHistoryCreate { }

// File Extraction
export interface FileExtractionGet {
  id: string;
  created_at: string;
  updated_at: string;
  file_id: string | null;
  status: ExternalFileStatus | null;
  energy_type: FileUploadEnergyType | null;
  file_type: FileUploadFileType | null;
  data: { [key: string]: any } | null;
  extracted_at: string | null;
}

export interface FileExtractionEventLogGet {
  ref_id: string;
  message: string;
  data: { [key: string]: any } | null;
}

// Extraction QA
export enum ExtractedByType {
  ERIK = 'ERIK',
  NEOX = 'NEOX',
  UPDATED = 'UPDATED'
}

export interface ExtractionQAStatsGet {
  id: string;
  file_id: string;
  energy_type: string;
  invoice_period_type: string;
  file_name: string | null;
  client_name: string | null;
  supplier_name: string | null;
  external_status_updated_at: string | null;
  total_fields: number;
  extracted_fields_old: number;
  extracted_fields_new: number;
  correct_fields_old: number;
  correct_fields_new: number;
  accuracy_old: number;
  accuracy_new: number;
}

export interface ExtractionQAGet {
  id: string;
  created_at: string;
  updated_at: string;
  file_id: string;
  extracted_by: ExtractedByType;
  energy_type: string;
  invoice_period_type: string;
  extraction_data: { [key: string]: any };
}

export interface ExtractionQAFileData {
  qa_records: ExtractionQAGet[];
  stats: ExtractionQAStatsGet | null;
}

// AI Summary
export interface QAAISummaryRequest {
  file_id: string;
  compare_from: ExtractedByType;
  compare_to: ExtractedByType;
  invoice_period_type?: string;
}

export interface QAAISummaryResponse {
  summary: string;
  highlights: string[];
  recommendations: string[];
}

// Field Error Rates
export enum FieldErrorType {
  NOT_EXTRACTED = 'NOT_EXTRACTED',
  WRONG_VALUE = 'WRONG_VALUE'
}

export enum KnownSupplier {
  A2A = 'a2a',
  BLUENERGY = 'bluenergy',
  DOLOMITI_ENERGIA = 'dolomiti_energia',
  ENEL = 'enel',
  HERA = 'hera',
  IREN = 'iren',
  ORANGY = 'orangy',
  SORGENIA = 'sorgenia',
  UNOENERGY = 'unoenergy',
  OTHER = 'other'
}

export interface FieldErrorRateItem {
  field_name: string;
  energy_type: string;
  invoice_period_type: string;
  extracted_by: ExtractedByType;
  error_type: FieldErrorType;
  supplier: KnownSupplier | null;
  count: number;
}

export interface SupplierErrorCount {
  supplier: string;
  count: number;
}

export interface FieldErrorRatesResponse {
  data: FieldErrorRateItem[];
  top_suppliers: SupplierErrorCount[];
}

// QA Stats Overview (line chart)
export interface QAStatsOverviewDay {
  date: string;
  accuracy_old: number;
  accuracy_new: number;
  file_count: number;
}

export interface QAStatsOverviewGet {
  data: QAStatsOverviewDay[];
}
